import { render, staticRenderFns } from "./CompletedSteps.vue?vue&type=template&id=a869896a&lang=pug&"
import script from "./CompletedSteps.vue?vue&type=script&lang=js&"
export * from "./CompletedSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports